export default {
  card: {
    minWidth: 150,
    maxHeight: 75,
    marginBottom: 20,
    marginRight: 10,
    padding: 0
  },
  content: {
    paddingTop: 10
  },
  carouselContainer: {
    backgroundColor: '#cccccc',
    border: '2px solid #444444'
  },
  carousel: {},
  carouselPicture: {
    maxHeight: '400px'
  },
  title: {
    marginBottom: 10,
    textAlign: 'center'
  },
  highlight: {
    textAlign: 'center',
    color: '#2196F3'
  }
};



// WEBPACK FOOTER //
// ./src/views/ViewCustomerCase/CasePictureCarousel/CasePictureCarousel.css.js